import React, { useState } from 'react';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CommonButton from '../../CommonComponents/CommonButton';
import { getProductUsers } from '../../redux/actions/dashusers';
import ProductUsersSubTable from './ProductUsersSubTable';

const ProductTableRow = ({
  row,
  getUsers,
  showProductAssignment,
}) => {
  const [open, setOpen] = useState(false)

  const getLocalUsers = (id) => {
    setOpen(!open)
    if (!open) {
      getUsers(id)
    }
  }

  return (
    <>
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={row.id}
      >
        <TableCell>
          {row.productName}
        </TableCell>
        <TableCell>
          {row.managerProduct
            ? (
              <CommonButton
                variant="outlined"
                color="primary"
                onClick={() => getLocalUsers(row.id)}
              >
                View Managers
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </CommonButton>
            )
            : null}
        </TableCell>
        <TableCell>
          <CommonButton
            variant="outlined"
            color="primary"
            onClick={() => showProductAssignment(row.id)}
          >
            Assign
          </CommonButton>
        </TableCell>
      </TableRow>
      <ProductUsersSubTable open={open} users={row.managerProduct} id={row.id} />
    </>
  );
}
const mapActions = {
  getUsers: getProductUsers,
};

export default connect(null, mapActions)(ProductTableRow);
